import { Component, ViewContainerRef } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { filter, tap } from 'rxjs/operators';

import { ActiveCartService } from '@spartacus/cart/base/core';
import { Cart } from '@spartacus/cart/base/root';
import { AddToSavedCartComponent } from '@spartacus/cart/saved-cart/components';
import { AuthService, RoutingService, User } from '@spartacus/core';
import { LaunchDialogService } from '@spartacus/storefront';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { UigCartService } from '../uig-cart.service';

@Component({
    selector: 'app-uig-add-to-saved-cart',
    templateUrl: './uig-add-to-saved-cart.component.html',
    styleUrls: ['./uig-add-to-saved-cart.component.scss'],
    standalone: false
})
export class UigAddToSavedCartComponent extends AddToSavedCartComponent {

  isRestricted: boolean = false;
  RIO_CART_ORDER: string = "rio_cart_order";
  RIO_CART_CREATE_UPDATE: string = "rio_cart_create_update";
  private userSubscription = new Subscription();
  activeCart$: Observable<string>;
  activeCartId: string;

  constructor(
    private uigCartService: UigCartService,
    protected activeCartService: ActiveCartService,
    protected authService: AuthService,
    protected routingService: RoutingService,
    protected launchDialogService: LaunchDialogService,
    protected vcr: ViewContainerRef,
    protected userAccountFacade: UserAccountFacade ) {

      super(activeCartService,
        authService,
        routingService,
        vcr, launchDialogService);

      this.activeCart$ = this.activeCartService.getActiveCartId();
      this.activeCart$.pipe(
        filter((activeCartId) => activeCartId != null),
        tap((activeCartId) => {
          this.activeCartId = activeCartId;
        })
      )
      .subscribe();
      this.checkForRoles();
}

  onExport() {
     this.uigCartService.printOrExportCart(this.activeCartId);
  }

  ngOnDestroy(): void {
    this.userSubscription.unsubscribe();
  }

  checkForRoles() {
    this.userSubscription = this.userAccountFacade
      .get()
      .pipe(filter((user: User) => user && Object.keys(user).length > 0))
      .subscribe((user) => {
        const hasRole =
          user.roles && (user.roles.includes(this.RIO_CART_CREATE_UPDATE)
            || user.roles.includes(this.RIO_CART_ORDER));
        if (!hasRole) {
          this.isRestricted = true;
        }
      });
  }

  onDelete() {
    this.uigCartService.openEmptyCartComponent(this.activeCartId);
  }

  saveCart(cart: Cart): void {
    if (this.loggedIn) {
      this.openDialog(cart);
    }
  }
}
